// extracted by mini-css-extract-plugin
export default {"wrapper":"l9-z"};